import styled from 'styled-components'
import { Card, LayoutHome } from './Layout/CommonStyle'
import Main from './Home/Main'
import TestList from './Common/TestList'

function Home() {
  return (
    <LayoutHome>
      <TestList />
      <Main />
    </LayoutHome>
  )
}

const Container = styled.div`
  grid-area: main;
  margin-bottom: 1rem;
`

const WriteCard = styled(Card)`
  display: flex;
  flex-direction: column;
  padding: 0.8rem;

  div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    button {
      margin: 4px 10px;
      flex-grow: 1;
      border-radius: 35px;
      padding-left: 16px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      background: transparent;
      text-align: left;
      min-height: 2.8rem;
    }

    .icon {
      font-size: 1.8rem;
    }
  }
`

export default Home
